/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {
  ajouterAnnee,
  handleDateValue,
  nextDateEffect,
  toDate,
} from '../../../../common/utils/date';
import {defaultValues} from '../../../../data/constants/Assurance/assuranceScolaire';
import {thousandSeparator} from '../../../../data/factory';
import {ApiResponse} from '../../../../data/types/interface/api';
import {StackParams} from '../../../../data/types/navigation';
import {ContratServices} from '../../../../services/applicatif/contrat';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {Header} from '../../../components/Header/HeaderSouscriptionScolaire';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';
import {Form} from './Forms/FormWeb';

type NavigationProps = StackNavigationProp<
  StackParams,
  'SouscriptionAssuranceScolaireForm'
>;

const data = {
  ...defaultValues,
};

const FSouscriptionAssuranceScolaireForm = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState([]);
  const [dataDto, setDataDto] = useState(data);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [prime, setPrime] = useState({moinsDouze: '', plusDouze: ''});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [minDateEffect, setMinDateEffect] = useState(new Date());

  const {
    getAgence,
    scolaireContrat,
    user,
    getDetailTypeassurance,
    contratEnCoursUser,
  } = props;
  const {getDetailContrat} = ContratServices();
  const userId =
    user && user.data && user.data.utilisateur && user.data.utilisateur.id;
  const isRenewal =
    props.route.params && props.route.params.typeAssurance == 'renouvellement';
  const [fromRedirection, setFromRedirection] = useState(false);
  const {montant, typeId} = props.route && props.route.params;

  useEffect(() => {
    if (props.route.params.montant !== ' ') {
      setFromRedirection(true);
    }
  }, [props.route.params && props.route.params.montant]);

  const updateData = (user: any) => {
    dataDto.adresse = user.adresse;
    dataDto.emailContractant = user.email;
    dataDto.dateNaissanceContractant = user.dateNaissance;
    dataDto.nomPrenomContractant = `${user.nom} ${user.prenom}`;
    dataDto.telephoneContractant = user.telephone;
    dataDto.telephoneContractantCountryCode = user.countryCode;
    return dataDto;
  };

  useEffect(() => {
    if (user && user.data && user.data.utilisateur) {
      const _data = updateData(user.data.utilisateur);
      // const _typeId = res.data.items[SCOLAIRE_PLACEMENT].id;
      const _urlMoinsDouzeAns = `?typeId=${typeId}&sousType=-12&montant=true`;
      const _urlPlusDouzeAns = `?typeId=${typeId}&sousType=12&montant=true`;
      let moins = '';
      let plus = '';
      getDetailTypeassurance(
        {},
        (res: ApiResponse) => {
          if (res && !res.isError && res.data) {
            moins = res.data.toString();
            setPrime({plusDouze: plus, moinsDouze: moins});
          }
        },
        _urlMoinsDouzeAns,
      );
      getDetailTypeassurance(
        {},
        (res: ApiResponse) => {
          if (res && !res.isError && res.data) {
            plus = res.data.toString();
            setPrime({plusDouze: plus, moinsDouze: moins});
          }
        },
        _urlPlusDouzeAns,
      );

      setDataDto({
        ...dataDto,
        ..._data,
        primeTTC: thousandSeparator(montant, ' '),
      });
    }
  }, [user]);

  useEffect(() => {
    const _agePortal = 12;
    const minDate = new Date();
    minDate.setFullYear(new Date().getFullYear() - _agePortal);
    let primeTTC = '';
    if (handleDateValue(dataDto.dateNaissanceEleveAssure) > minDate) {
      primeTTC = thousandSeparator(prime.moinsDouze, ' ');
    } else {
      primeTTC = thousandSeparator(prime.plusDouze, ' ');
    }
    dataDto.primeTTC = primeTTC;
  }, [prime, dataDto]);

  const mapAgence = (list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.nom,
        label: e.nom,
      };
    });
    return list;
  };

  useEffect(() => {
    setIsLoading(true);
    getAgence({}, (res: any) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);
        setListAgence(_list);
        if (isRenewal) {
          getDetailContrat(props.user.numeroPolice)
            .then(res => {
              const contrat = res.data;
              const _minDateEffect = nextDateEffect(
                contrat.versions[0].dateEcheance,
              );
              setMinDateEffect(toDate(_minDateEffect));
              setDataDto({
                ...dataDto,
                agence: contrat.agence,
                dateEffet: _minDateEffect,
                dateNaissanceEleveAssure: contrat.dateNaissanceEleveAssure,
                nomPrenomEleveAssure: contrat.nomPrenomEleveAssure,
                etablissementScolaire: contrat.etablissementScolaire,
                anneeScolaire: ajouterAnnee(contrat.anneeScolaire),
              });
            })
            .finally(() => setIsLoading(false));
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    });
  }, []);

  const handleCancel = useCallback(() => {
    goBack();
  }, []);

  const handleSubmit = (response: any) => {
    const _data = {...response};
    _data.dateNaissanceEleveAssure = toDate(response.dateNaissanceEleveAssure);
    _data.dateNaissanceContractant = toDate(response.dateNaissanceContractant);
    //add dateEffet
    _data.dateEffet = toDate(response.dateEffet);
    setIsLoading(true);
    scolaireContrat(
      {
        ...response,
        operationType: 'simulation',
        simulationId: '',
        utilisateur: userId,
      },
      (res: any) => {
        setIsLoading(false);
        if (res && !res.isError && res.data) {
          _data.dateNaissanceContractant = toDate(
            response.dateNaissanceContractant,
          );
          //add dateEffet
          _data.dateEffet = toDate(response.dateEffet);
          setDataDto(_data);
          const _reponse = {
            ...response,
            operationType: 'create',
            simulationId: res.data.id,
            utilisateur: userId,
            dateEffet: _data.dateEffet,
          };
          contratEnCoursUser({
            numeroPolice: isRenewal ? props.user.numeroPolice : undefined,
            typeContrat: 'scolaire',
            typePayment: isRenewal ? 'renouvellement' : 'souscription',
            ..._reponse,
          });
          setPostSuccess(true);
        } else {
          setErrorMessage(res.message);
          setShowErrorModal(true);
        }
      },
    );
  };

  const redirectToPayment = () => {
    setPostSuccess(false);
    navigate('Payement');
  };

  return (
    <View>
      <HeaderScreen
        title={isRenewal ? 'Renouvellement' : 'Souscription'}
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {postSucces && (
          <ConfirmationModal
            title="Assurance Scolaire"
            content={`Pour finaliser votre ${
              isRenewal ? 'renouvellement' : 'souscription'
            }, veuillez procéder au paiement.`}
            btn1="OK"
            handleBtn1={redirectToPayment}
          />
        )}
        {/** Error modal */}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Header content */}
        {!IsLoading && !postSucces && !showErrorModal && (
          <Header isRenewal={isRenewal} />
        )}
        {/** Form content */}
        {!postSucces && !IsLoading && !showErrorModal && (
          <Form
            fromRedirection={fromRedirection}
            data={dataDto}
            prime={prime}
            listAgence={listAgence}
            isRenewal={isRenewal}
            minDateEffect={minDateEffect}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const SouscriptionAssuranceScolaire = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FSouscriptionAssuranceScolaireForm);
